<template>
  <div class="firstLoading">
    <div class="loading-block">
      <div v-if="loading">{{loadingContent}}</div>
    </div>
  </div>
</template>
<script>
  import http from "../../../api/index.js";
  import config from "../../../utils/config";
  import dayjs from 'dayjs';

  export default {
    data() {
      return {
        loading: true,
        loadingContent: "加载中...",
        taskNo: "",
        autoLoginForm: {
          appId: "",
          nonceStr: "",//随机数
          sign: "",//签名秘钥
          mobile: "",
          // appId: "1370986503395610626",
          // nonceStr: "153990756158595",
          // sign: "2ED588C6CE9908A9D0F33E58BEE7C1A7",
          // taskNo: "40161112890007805766"
        }
      }
    },
    mounted() {
      const url = new URL(location.href);
      this.autoLoginForm.appId = url.searchParams.get('appId');
      this.autoLoginForm.nonceStr = url.searchParams.get('nonceStr');
      this.autoLoginForm.sign = url.searchParams.get('sign');
      this.autoLoginForm.mobile = url.searchParams.get('mobile');

      this.taskNo = url.searchParams.get('taskNo');

      if (this.taskNo) {
        sessionStorage.setItem('taskNo', this.taskNo);
      } else {
        sessionStorage.removeItem("taskNo");
      }
      let thirdRedirectUrl = url.searchParams.get('redirectUrl') || "";
      if (thirdRedirectUrl) {
        sessionStorage.setItem("thirdRedirectUrl", thirdRedirectUrl);
      } else {
        sessionStorage.removeItem("thirdRedirectUrl");
      }
      this.autoLogin();
    },
    methods: {
      autoLogin() {
        http.post(config.h5AutoLogin, this.autoLoginForm).then(({code, data, message}) => {
          if (code === 0 && data.code === 200) {
            sessionStorage.setItem('user_mobile', this.autoLoginForm.mobile);
            this.saveVersion();
            if (this.taskNo) {
              http.post(config.scanOrderJump, {taskNo: this.taskNo}).then(({code, data, message}) => {
                if (code === 0) {
                  if (data.code === 6201) {
                    this.$router.push({path: "../taskDetail"});
                  } else if (data.code === 6202) {
                    location.href = data.signUrl;
                    sessionStorage.removeItem("taskNo");
                  } else {
                    this.$router.push({path: "../updateInfo"});
                    sessionStorage.removeItem("taskNo");
                  }
                }
              });
            } else {
              sessionStorage.setItem('user_mobile', this.autoLoginForm.mobile);
              this.$router.push({path: '/updateInfo'});
            }
          } else {
            this.loadingContent = message;
            // this.$toast.fail(message);
          }
        });
      },
      // 登录保存的信息
      saveVersion() {
        http.post(config.loginRecord, {
          systemVersion: sessionStorage.getItem("Edition"),
          systemModel: sessionStorage.getItem("Model"),
          loginType: "h5",
          appVersion: "1.0.5",
          // lastLoginTime:new Date().Format("yyyy-MM-dd hh:mm:ss"),
          lastLoginTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")
        }).then((e) => {
        });
      },
    }
  }
</script>
<style lang="less" scoped>
  .firstLoading {
    width: 100%;
    height: 100%;
  }

  .loading-block {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/entryFile/takeLoading/index.vue